import { EmailInput } from '@rentnerkev/inputs/email-input'
import { Link } from '@tanstack/react-router'
import { ArrowLeft, Mail } from 'lucide-react'

import usePasswordForgotLogic from '@/features/Auth/ForgotPassword/Hooks/usePasswordForgotLogic.ts'
import useTranslationStore from '@/language/useTranslationStore'

export default function ForgotPassword() {
    const { t } = useTranslationStore()
    const { state } = usePasswordForgotLogic()

    return (
        <div className="flex w-full items-center justify-center">
            <div className="border-border-dark bg-surface-dark/95 w-full max-w-md rounded-xl border p-8 backdrop-blur">
                <div className="mb-6 text-center">
                    <h2 className="text-2xl font-bold text-white">
                        {t('auth.forgotPassword.title')}
                    </h2>
                    <p className="text-secondary-text mt-1 text-sm">
                        {t('auth.forgotPassword.description')}
                    </p>
                </div>

                <form
                    onSubmit={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        state.form.handleSubmit()
                    }}
                    className="space-y-5"
                >
                    <state.form.Field
                        name="email"
                        children={(field) => (
                            <EmailInput
                                name={field.name}
                                onBlur={field.handleBlur}
                                aria-label={t(
                                    'auth.forgotPassword.emailPlaceholder',
                                )}
                                id={field.name}
                                value={field.state.value}
                                required
                                onValueChange={field.handleChange}
                                placeholder={t(
                                    'auth.forgotPassword.emailPlaceholder',
                                )}
                                icon={<Mail className="h-5 w-5" />}
                                maxLength={120}
                                showLength={true}
                            />
                        )}
                    />
                    <button
                        type="submit"
                        disabled={state.isLoading}
                        className="bg-primary hover:bg-primary-hover focus-visible:outline-primary mt-6 flex w-full cursor-pointer justify-center rounded-md px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
                    >
                        {state.isLoading
                            ? t('auth.forgotPassword.requesting')
                            : t('auth.forgotPassword.requestLink')}
                    </button>
                </form>

                <Link
                    to="/login"
                    className="text-secondary-text mt-5 flex items-center justify-center gap-2 text-sm font-medium transition-colors hover:text-white"
                >
                    <ArrowLeft className="h-4 w-4" />
                    {t('common.backToLogin')}
                </Link>
            </div>
        </div>
    )
}
